<template>
  <Box>
    <template #content>
      <div class="table_main">
        <div class="query">
          <div class="left">
            <el-form ref="query_form" :model="queryParams" label-width="80px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="设备编号" prop="nnc">
                    <el-input size="small" v-model="queryParams.nnc"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="所在企业" prop="companyname">
                    <el-input size="small" v-model="queryParams.companyname"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="设备状态" prop="sbstate">
                    <el-select v-model="queryParams.sbstate" size="small" clearable>
                      <el-option v-for="item in sbstate" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="省市区" prop="qy">
                    <Region :qy="queryParams.qy" @change="change" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="right">
            <Btn @click="query" round>
              <span class="btn_box">
                <i class="iconfont icon-sousuo"></i>
                <span>搜索</span>
              </span>
            </Btn>
            <Btn @click="initQuery" round>
              <span class="btn_box">
                <i class="iconfont icon-chongzhi"></i>
                <span>重置</span>
              </span>
            </Btn>
          </div>
        </div>
        <div class="content">
          <Table :datas="tableData" :heads="tableHead" :nowStatus="queryParams.sbstate" :selection="false" :loading="loading">
            <template #handle="data">
              <div class="table_cell">
                <span v-if="data.head.handle == 'index'">{{
                (pageData.page - 1) * pageData.pageSize + data.index
                }}</span>
                <span v-if="data.head.handle == 'onlineState'" :class="['pre']">
                  <span class="_pre" :style="{
                    background: (
                      onlineState.find(
                        (a) => a.value == data.data.onlineState
                      ) || { color: '' }
                    ).color,
                  }"></span>
                  <span>{{
                  (
                  onlineState.find(
                  (a) => a.value == data.data.onlineState
                  ) || { label: "" }
                  ).label
                  }}</span>
                </span>
                <span v-if="data.head.handle == 'sbstate'" :class="['pre']">
                  <span class="_pre" :style="{
                    background: (
                      sbstate.find((a) => a.value == data.data.sbstate) || {
                        color: '',
                      }
                    ).color,
                  }"></span>
                  <span>{{ data.data.sbstate }}</span>
                </span>
                <div v-if="data.head.handle == 'btns'">
                  <Btn type="text" v-if="hasPermi('system:sbinfo:updateSbInfoStateById')"
                    @click="handleItem(data.data, '状态设置')">状态设置</Btn>
                  <Btn type="text" v-if="hasPermi('system:jbh:jbhList')"
                    @click="toPath(`/SignManagementAndCheck`, data.data)">卷标号管理</Btn>
                </div>
              </div>
            </template>
          </Table>
          <el-pagination class="page" background layout="total, sizes, prev, pager, next" :total="pageData.total" :page-sizes = "[10, 20, 50, 100]"
            :current-page.sync="pageData.page" :page-size.sync="pageData.pageSize" @size-change="query" @current-change="getList">
          </el-pagination>
        </div>
      </div>
      <Drawer :open="open" @changeOpen="changeOpen" :title="drawerTitle">
        <template #content>
          <el-form :model="addForm" ref="addForm" label-width="130px" :class="['demo-ruleForm', 'formBox']">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="设备状态：" prop="sbstate">
                  <el-select v-model="addForm.sbstate" size="small">
                    <el-option v-for="item in sbstate" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="状态修改原因：" prop="upremark">
                  <el-input type="textarea" v-model="addForm.upremark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="修改时间：" prop="updateTime">
                  <el-date-picker size="small" v-model="addForm.updateTime" type="date" placeholder="选择日期"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled>
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="操作人：" prop="createUser">
                  <el-input size="small" v-model="addForm.createUser" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
        <template #footer>
          <Btn type="blue" @click="commitData">提交</Btn>
          <Btn @click="closeDrawer">取消</Btn>
        </template>
      </Drawer>
    </template>
  </Box>
</template>

<script>
import { sbstate, onlineState } from "@/utils/status";
import drawerMixins from "@/components/drawer/drawer";
import {
  sbStateManage,
  updateSbInfoStateById,
} from "@/api/DeviceRunManagement";
import moment from "moment";
import { upDateDevice, queryDevice } from "@/api/DeviceManagement";
import Region from "@/components/region";
import permMixin from "@/mixins/perm";
export default {
  mixins: [drawerMixins, permMixin],
  components: { Region },
  data() {
    return {
      sbstate,
      onlineState,
      drawerTitle: "详情",
      queryParams: {
        nnc: "",
        companyname: "",
        qy: "",
        sccode: "",
        sbstate: "",
      },
      ywryData: [],
      tableData: [],
      tableHead: [
        {
          prop: "xh",
          label: "序号",
          handle: "index",
          width: 50,
          textAlign: "center",
        },
        {
          label: "部署企业",
          prop: "companyname",
          minWidth: 280,
        },
        {
          label: "生产线",
          prop: "sccode",
          textAlign: "center",
        },
        {
          label: "设备编号",
          prop: "nnc",
        },
        {
          label: "型号",
          prop: "xh",
        },
        {
          label: "设备状态",
          prop: "sbstate",
          handle: "sbstate",
          textAlign: "center",
        },
        {
          label: "在线状态",
          prop: "onlineState",
          handle: "onlineState",
          textAlign: "center",
        },
        {
          label: "联系人",
          prop: "userName",
        },
        {
          label: "联系电话",
          minWidth: 110,
          prop: "phone",
        },
        {
          label: "上线日期",
          prop: "uptime",
          minWidth: 100,
        },
        {
          prop: "cz",
          label: "操作",
          handle: "btns",
          width: 200,
          fixed: "right",
        },
      ],
      tableSelected: [],
      addForm: {
        sbstate: "启用",
        upremark: "",
        updateTime: "",
        createUser: "",
      },
      initAddForm: {
        sbstate: "启用",
        upremark: "",
        updateTime: "",
        createUser: "",
      },
      loading: false,
      pageData: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      tempData: {
        sbstate: "",
      },
    };
  },
  methods: {
    change(val) {
      this.queryParams.qy = val;
    },
    async handleItem(data, drawerTitle) {
      this.drawerTitle = drawerTitle;
      await queryDevice(data.id).then((res) => {
        this.addForm = {
          ...this.addForm,
          ...res.data,
        };
      });
      this.tempData.sbstate = data.sbstate;
      this.changeOpen();
    },
    commitData() {
      // const params = {
      //   ...this.addForm,
      //   createUser: this.$store.state.userStore.userMsg.userName,
      // };
      // if (params.sbstate !== this.tempData.sbstate)
      //   params.uptime = moment().format("YYYY-MM-DD");
      // delete params.updateTime;
      // upDateDevice(this.addForm).then((res) => {
      //   this.$message({
      //     message: "操作成功",
      //     type: "success",
      //   });
      //   this.$refs.addForm.resetFields();
      //   this.addForm = {
      //     ...this.initAddForm,
      //   };
      //   this.changeOpen();
      //   this.getList();
      // });
      const params = {
        id: this.addForm.id,
        sbstate: this.addForm.sbstate,
        upremark: this.addForm.upremark,
        uptime: moment().format("YYYY-MM-DD"),
      };
      updateSbInfoStateById(params).then(() => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$refs.addForm.resetFields();
        this.addForm = {
          ...this.initAddForm,
        };
        this.changeOpen();
        this.getList();
      });
    },
    initQuery() {
      this.pageData.page = 1;
      this.$refs.query_form.resetFields();
      this.queryParams.qy = "";
    },
    query() {
      this.pageData.page = 1;
      this.getList();
    },
    getList() {
      this.loading = true
      const params = {
        ...this.queryParams,
        currentPage: this.pageData.page,
        pageSize: this.pageData.pageSize
      };
      sbStateManage(params)
        .then((res) => {
          this.pageData.total = res.data.count;
          res.data.list.forEach((item) => {
            item.uptime = item.uptime?.substr(0, 10) || "";
          });
          this.tableData = res.data?.list || [];
          this.loading = false
        })
        .catch((err) => {
          this.pageData.total = 0;
          this.tableData = [];
          this.loading = false
        });
    },
    toPath(path, data) {
      this.$router.push({
        path,
        query: {
          id: data.id,
          companyname: data.companyname,
          nnc: data.nnc,
        },
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.table_main .query {
  min-height: 87px;
}
</style>
